import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HFlex = styled(Box)`
  display: flex;
  flex-direction: row;
`;

export const VFlex = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const AlignItemsCenter = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CenteredFlex = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
